import rightArrow from '@brands/Dashboard/Dashboard/Patient/components/rightArrow.svg';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Button } from '@mui/material';
import React from 'react';

import patientEducationImage2 from './IMG_0236.png';
import patientEducationImage1 from './IMG_0238.png';
import patientEducationImage3 from './IMG_0239.png';
import styles from './styles.module.scss';

const PatientEducation = (): JSX.Element => {
  return (
    <div className={`fs-unmask ${styles.patientEducationDiv}`}>
      <div className={styles.patientEducationTitle}>
        <span className="fs-unmask">Patient education</span>
      </div>
      <div className={styles.patientEducationCards}>
        <div className={styles.patientEducationCard}>
          <div className={`fs-unmask ${styles.patientEducationCardImage}`}>
            <img src={patientEducationImage1} />
          </div>
          <div className={`fs-unmask ${styles.patientEducationCardText}`}>
            <span>Dental Emergencies: What to Do and When to See a Dentist</span>
          </div>
          <div className={`fs-unmask ${styles.patientEducationCardAuthor}`}>
            <span>Learn what counts as a dental emergency, how to handle it, and when to see a doctor or dentist.</span>
          </div>
          <div className={`fs-unmask ${styles.patientEducationCardLink}`}>
            <Button
              className={styles.readMoreButton}
              target="_blank"
              href="https://dentistry.one/resources/dental-emergency-guide/"
              rel="noreferrer"
            >
              <span>Read more</span>
              <NavigateNextIcon />
            </Button>
          </div>
        </div>

        <div className={styles.patientEducationCard}>
          <div className={`fs-unmask ${styles.patientEducationCardImage}`}>
            <img src={patientEducationImage2} />
          </div>
          <div className={`fs-unmask ${styles.patientEducationCardText}`}>
            <span>Bleeding Gums: Causes, Treatment, and When to See a Dentist</span>
          </div>
          <div className={`fs-unmask ${styles.patientEducationCardAuthor}`}>
            <span>
              If you’ve noticed some bleeding when brushing or flossing, you’re not alone. It’s often a sign that your
              gums need a little extra attention.
            </span>
          </div>
          <div className={`fs-unmask ${styles.patientEducationCardLink}`}>
            <Button
              className={styles.readMoreButton}
              target="_blank"
              href="https://dentistry.one/resources/bleeding-gums-treatment/"
              rel="noreferrer"
            >
              <span>Read more</span>
              <NavigateNextIcon />
            </Button>
          </div>
        </div>

        <div className={styles.patientEducationCard}>
          <div className={`fs-unmask ${styles.patientEducationCardImage}`}>
            <img src={patientEducationImage3} />
          </div>
          <div className={`fs-unmask ${styles.patientEducationCardText}`}>
            <span>Why Does My Tooth Hurt? Understanding, Treating, and Preventing Tooth Pain</span>
          </div>
          <div className={`fs-unmask ${styles.patientEducationCardAuthor}`}>
            <span>
              Learn about the common types of tooth pain, how to identify the cause, and simple steps to relieve
              discomfort.
            </span>
          </div>
          <div className={`fs-unmask ${styles.patientEducationCardLink}`}>
            <Button
              className={styles.readMoreButton}
              target="_blank"
              href="https://dentistry.one/resources/tooth-pain-causes-treatment-2/"
              rel="noreferrer"
            >
              <span>Read more</span>
              <NavigateNextIcon />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PatientEducation;
